import script from "./NoviceFilterChips.vue?vue&type=script&setup=true&lang=js"
export * from "./NoviceFilterChips.vue?vue&type=script&setup=true&lang=js"

import "./NoviceFilterChips.vue?vue&type=style&index=0&id=a5addf16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5addf16"]])

export default __exports__